module.exports = __webpack_public_path__ + "static/media/500-Error-art.256dc47d.png";